import React, { Component, useState } from 'react';
import './Carousel.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CarouselImageCard from '../../cards/carouselImageCard';
import EditorConfirmation from '../../cards/editorExitConfirmation';
import { useDispatch } from 'react-redux';
import { updateEditorCloseState } from '../../../../redux/slices/lomavisCreator/lomavisCreator';

interface CarouselProps {
  items: any[];
  setSelectedIndex: React.Dispatch<any>;
  selectedFile: any;
  setEditorChanged: React.Dispatch<React.SetStateAction<boolean>>;
  editorChanged: boolean;
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`cursor-pointer ${className}`}
      style={{ display: 'block' }}
      onClick={onClick}
    >
      <i style={{ fontSize: '50px' }} className="fa-duotone fa-caret-right"></i>
    </div>
  );
}
function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`cursor-pointer ${className}`}
      style={{ display: 'block' }}
      onClick={onClick}
    >
      <i style={{ fontSize: '50px' }} className="fa-duotone fa-caret-left "></i>
    </div>
  );
}

const Carousel: React.FC<CarouselProps> = ({
  items,

  selectedFile,
  setEditorChanged,
  setSelectedIndex,
  editorChanged
}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [currentItem, setCurrentItem] = useState(0);

  return (
    <div
      style={{ overflowY: 'auto' }}
      className="w-100 h-100 d-flex flex-column justify-content-start align-items-start gap-2 mx-auto"
    >
      <EditorConfirmation
        handleClose={() => setShow(false)}
        handleClear={() => {
          setSelectedIndex(currentItem);
          setEditorChanged(false);
          dispatch(
            updateEditorCloseState({
              state: false
            })
          );
        }}
        show={show}
      />
      {items.map((item, index) => {
        return (
          <div key={`imageCard-${item?.id}`} className="mx-auto">
            <div
              onClick={() => {
                setCurrentItem(index);
                editorChanged ? setShow(true) : setSelectedIndex(index);
              }}
              className={`cursor-pointer bg-danger`}
            >
              <CarouselImageCard
                active={selectedFile.id === item.id ? true : false}
                image={
                  item.preview_image ? item.preview_image : item.thumbnail_image
                }
                item={item}
                key={item.id}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Carousel;
